import { render, staticRenderFns } from "./BasePcThreeBaiduTop.vue?vue&type=template&id=3372601a&scoped=true&"
import script from "./BasePcThreeBaiduTop.vue?vue&type=script&lang=ts&"
export * from "./BasePcThreeBaiduTop.vue?vue&type=script&lang=ts&"
import style0 from "./BasePcThreeBaiduTop.vue?vue&type=style&index=0&id=3372601a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372601a",
  null
  
)

export default component.exports